import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-418d5788"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "images top_spacing-0 bottom_spacing-0" };
export default /*#__PURE__*/ _defineComponent({
    __name: 'carousel',
    props: ['d'],
    setup(__props) {
        const props = __props;
        function carouselData() {
            return {
                image_carousel_images: carouselItems(),
                width: 'full-width'
            };
        }
        function carouselItems() {
            let carouselItems = [];
            for (const item of props.d.carousel_items) {
                carouselItems.push({
                    image: item.image,
                    alt: item.image_alt_tag
                });
            }
            return carouselItems;
        }
        return (_ctx, _cache) => {
            const _component_image_carousel = _resolveComponent("image-carousel");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_image_carousel, {
                    d: carouselData()
                }, null, 8, ["d"])
            ]));
        };
    }
});
